'use client';
import React, { useEffect, useRef } from 'react';

export default function HeroSection() {
  const headlineRef = useRef<HTMLHeadingElement>(null);
  const subRef = useRef<HTMLParagraphElement>(null);
  const statsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const targets = [headlineRef?.current, subRef?.current, statsRef?.current];
    targets?.forEach((el, i) => {
      if (!el) return;
      setTimeout(() => {
        el.style.animation = `fadeUpIn 1s cubic-bezier(0.22,0.68,0,1) forwards`;
        el.style.opacity = '1';
      }, 300 + i * 200);
    });
  }, []);

  return (
    <section className="relative w-full min-h-screen flex items-end overflow-hidden">
      {/* Banner background */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(/assets/images/banner3.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'grayscale(30%) brightness(0.95) opacity(0.5)',
        }}
      />
      {/* Gradient overlay */}
      <div className="absolute inset-0 z-[1] bg-gradient-to-t from-canopy/95 via-canopy/50 to-canopy/20" />
      <div className="absolute inset-0 z-[2] bg-gradient-to-r from-canopy/60 via-transparent to-canopy/30" />
      {/* Blueprint grid */}
      <div className="absolute inset-0 z-[3] blueprint-grid opacity-60" />
      {/* Noise */}
      <div className="absolute inset-0 z-[4] noise-overlay" />
      {/* Corner annotations */}
      <div className="absolute top-24 left-6 z-10 annotation opacity-60">
        <div>FACILITY: ATN-MAIN-01</div>
        <div>LAT: -0.5697° S · LON: 117.2593° E</div>
        <div>STATUS: OPERATIONAL</div>
      </div>
      <div className="absolute top-24 right-6 z-10 annotation text-right opacity-60">
        <div>500+ HOSTSPOT</div>
        <div>KALIMANTAN TIMUR</div>
        <div>SEJAK 2025</div>
      </div>
      {/* Main content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-36 pb-20 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7 flex flex-col gap-8">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-chartreuse/30 rounded-sm w-fit">
            <span className="w-2 h-2 rounded-full bg-chartreuse animate-pulse" />
            <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-chartreuse">
              Solusi Pertanian Modern · Smart Farming
            </span>
          </div>
          <h1
            ref={headlineRef}
            className="font-mono font-bold leading-[0.9] tracking-tighter text-fern"
            style={{ fontSize: 'clamp(2.5rem, 7vw, 5.5rem)', opacity: 0 }}>
            KEMBANGKAN<br />
            <span className="text-text-primary">PERTANIAN ANDA</span><br />
            DENGAN<br />
            <span className="text-chartreuse">SMART FARMING</span>
          </h1>
          <p
            ref={subRef}
            className="text-text-muted text-lg md:text-xl leading-relaxed max-w-xl font-medium"
            style={{ opacity: 0 }}>
            Integrasikan pertanian modern, edukasi untuk petani masa depan demi meningkatkan
            produktivitas sistem pertanian berkelanjutan.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            {/* <a
              href="/quote"
              className="btn-chartreuse px-8 py-4 rounded-sm text-sm uppercase tracking-widest text-center">
              Hubungi Kami
            </a> */}
            <button
              className="btn-outline-chartreuse px-8 py-4 rounded-sm text-sm uppercase tracking-widest"
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}>
              Pelajari Lebih Lanjut
            </button>
          </div>
        </div>
        {/* Stats */}
        <div
          ref={statsRef}
          className="lg:col-span-5 grid grid-cols-2 gap-4"
          style={{ opacity: 0 }}>
          {[
            { label: 'Titik Hotspot', value: '22', unit: 'Perangkat Terhubung' },
            { label: 'Klien', value: '8', unit: 'Kelompok' },
            { label: 'Pengguna Aktif', value: '98', unit: 'Pengguna' },
            { label: 'Pelatihan & Edukasi', value: '538', unit: 'Peserta' },
          ].map((stat) =>
          <div key={stat.label} className="glass-card rounded-sm p-5 stat-card">
              <div className="annotation mb-2">{stat.label.toUpperCase()}</div>
              <div className="font-mono font-bold text-chartreuse text-2xl md:text-3xl leading-none">
                {stat.value}
              </div>
              <div className="font-mono text-[10px] text-text-muted mt-1 tracking-widest uppercase">
                {stat.unit}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 z-10 rule-line" />
    </section>
  );
}
